function Vehiculos(params) {
    return (
        <>
            Vehiculos
        </>
    )
}

export default Vehiculos